<template>
    <div class="tip">
        <div class="tip-top" @click="closeTip = !closeTip">
            <img :src="closeTip ? require('./img/hui.png') : require('./img/hei.png') " alt="">
            <div class="title" :style="closeTip ? 'color:#969FA9':''">{{ title }}</div>
        </div>
        <div class="tip-content" v-if="!closeTip" v-html="text"></div>
    </div>
</template>
<script>
    export default {
        name: 'Tip',
        props: {
            title: {
                type: String,
                default: '话术提示：'
            },
            text: {
                type: String,
                default: ''
            },
        },
        data: function () {
            return {
                closeTip: true
            }
        }
    }
</script>
<style lang="scss" scoped>
    .tip {
        padding: 5px 16px;
        .tip-top {
            width: 100%;
            padding: 16px 0;
            display: flex;
            align-items: center;

            img {
                width: 16px;
                height: 10px;
            }

            .title {
                color: #222;
                font-size: 13px;
                margin-left: 10px;
            }
        }
        .tip-content {
            background: #FAFAFA;
            font-size: 12px;
            color: #969FA9;
            position: relative;
            line-height: 26px;
            padding: 18px 10px;
            &:after{
                display: block;
                content: '';
                background: #FAFAFA;
                width: 12px;
                height: 12px;
                position: absolute;
                top: -6px;
                transform: rotate(45deg);
                left: 26px;
            }
        }
    }

</style>
